export default __webpack_public_path__ + "static/media/f6.6b235200.jpg";